import { Drawer, Button, message, Form, Input, Select } from 'antd';

import {RoleTemplateApi,AreaApi} from "gmrfid-service-user-api-client"
import {AdminRoleApi} from "gmrfid-service-user-api-manager"
import React, { useEffect, useState } from 'react';
import { DrawerStyle } from './style';
import { debounce } from 'lodash';

const { Option } = Select;

const Add = ({ setShowDrawer, showDrawer, tableObj, setTableTime, setTableObj, mode }) => {
  const [form] = Form.useForm();
  const [provinceCodeData, setProvinceCodeData] = useState([]); // 省
  const [cityCodeData, setCityCodeData] = useState([]); // 城市
  const [areaCodeData, setAreaCodeData] = useState([]); // 区、县
  const [streetCodeData, setStreetCodeData] = useState([]); // 街道
  const [communityData, setCommunityData] = useState([]); // 社区
  const [code, setCode] = useState(null);
  const [provinceCode, setProvinceCode] = useState(null);
  const [cityCode, setCityCode] = useState(null);
  const [areaCode, setAreaCode] = useState(null);
  const [streetCode, setStreetCode] = useState(null);
  const [communityCode, setCommunityCode] = useState(null);
  const [province, setProvince] = useState(null);
  const [city, setCity] = useState(null);
  const [area, setArea] = useState(null);
  const [street, setStreet] = useState(null);
  const [community, setCommunity] = useState(null);
  const [PCode, setPCode] = useState(null);
  const [comboData, setComboData] = useState([]);
  const [value, setValue] = useState();

  useEffect(() => {
    RoleTemplateApi.simpleList({
      form: {
        keyWords: value,
      },
    }).then((res) => {
      setComboData([]);
      if (res && res.status === 200) {
        setComboData(res.data || []);
      }
    });
  }, [value]);
  useEffect(() => {
    if (tableObj?.id) {
      form.setFieldsValue({
        name: tableObj?.name,
      });
    }
  }, [tableObj]);

  const onClose = () => {
    setShowDrawer(false);
    setTableObj({});
  };

  const onFinish = (values) => {
    const par = {
      roleTemplateId: values?.roleTemplateId,
      organizeIds: [tableObj?.id],
    };
   AdminRoleApi.updateRoleTemplate({
      form: par,
    }).then((res) => {
      if (res && res.status === 200) {
        message.success('操作成功');
        setTableTime(Math.random());
        onClose();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  /* 省、市、区县、街道、社区 */
  useEffect(() => {
    AreaApi.simpleList({
      param: {
        PCode,
      },
    }).then((res) => {
      if (res.data) {
        switch (code) {
          case 'CS':
            setCityCodeData(res.data);
            break;
          case 'QX':
            setAreaCodeData(res.data);
            break;
          case 'JD':
            setStreetCodeData(res.data);
            break;
          case 'SQ':
            setCommunityData(res.data);
            break;
          default:
            setProvinceCodeData(res.data);
            break;
        }
      }
    });
  }, [PCode]);

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      setValue(value);
    };
    return debounce(loadOptions, 800);
  }, []);

  return (
    <Drawer
      title=""
      placement="right"
      size="large"
      onClose={onClose}
      visible={showDrawer}
      className="drawerModal"
      destroyOnClose
      width={720}
    >
      <DrawerStyle>
        <div className="drawer-top">
          <h1>
            {mode === 'single' ? '配置套餐' : '批量配置'}
            <div className="clear" onClick={onClose}>
              x
            </div>
          </h1>
        </div>
        <div className="drawer-content">
          <Form className="form" name="basic" form={form} onFinish={onFinish} onFinishFailed={onFinishFailed}>
            {mode === 'single' && (
              <Form.Item
                label="项目名称"
                name="name"
                rules={[
                  {
                    required: false,
                    message: '请输入项目名称',
                    max: 20,
                  },
                ]}
              >
                <Input style={{ width: 400 }} disabled />
              </Form.Item>
            )}
            {mode === 'multiple' && (
              <>
                <Form.Item name="provinceCode" label="行政区划" rules={[{ required: true, message: '请选择省份' }]}>
                  <Select
                    placeholder="请选择省份"
                    onChange={(v, e) => {
                      setCode('CS');
                      setProvinceCode(v);
                      setProvince(e.name);
                      setPCode(v);
                      form.setFieldsValue({
                        cityCode: '',
                        areaCode: '',
                        streetCode: '',
                        communityCode: '',
                      });
                    }}
                  >
                    {provinceCodeData.map((item, i) => (
                      <Option key={i} value={item.code} name={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="cityCode"
                  label="城市"
                  className="labelName"
                  rules={[{ required: true, message: '请选择城市' }]}
                >
                  <Select
                    placeholder="请选择城市"
                    onChange={(v, e) => {
                      setCode('QX');
                      setCityCode(v);
                      setCity(e.name);
                      setPCode(v);
                      form.setFieldsValue({
                        areaCode: '',
                        streetCode: '',
                        communityCode: '',
                      });
                    }}
                  >
                    {cityCodeData.map((item, i) => (
                      <Option key={i} value={item.code} name={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="areaCode"
                  className="labelName"
                  label="区、县"
                  rules={[{ required: true, message: '请选择区、县' }]}
                >
                  <Select
                    placeholder="请选择区、县"
                    onChange={(v, e) => {
                      setCode('JD');
                      setAreaCode(v);
                      setArea(e.name);
                      setPCode(v);
                      form.setFieldsValue({
                        streetCode: '',
                        communityCode: '',
                      });
                    }}
                  >
                    {areaCodeData.map((item, i) => (
                      <Option key={i} value={item.code} name={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="streetCode"
                  className="labelName"
                  label="街道"
                  rules={[{ required: true, message: '请选择街道' }]}
                >
                  <Select
                    placeholder="请选择街道"
                    onChange={(v, e) => {
                      setCode('SQ');
                      setStreetCode(v);
                      setStreet(e.name);
                      setPCode(v);
                      form.setFieldsValue({
                        communityCode: '',
                      });
                    }}
                  >
                    {streetCodeData.map((item, i) => (
                      <Option key={i} value={item.code} name={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="communityCode"
                  className="labelName"
                  rules={[
                    {
                      required: true,
                      message: '请选择社区',
                    },
                  ]}
                  label="社区"
                >
                  <Select
                    placeholder="请选择社区"
                    onChange={(v, e) => {
                      setCommunityCode(v);
                      setCommunity(e.name);
                    }}
                  >
                    {communityData.map((item, i) => (
                      <Option key={i} value={item.code} name={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </>
            )}
            <Form.Item label="套餐" name="roleTemplateId" rules={[{ required: true, message: '请选择套餐' }]}>
              <Select
                placeholder="请选择"
                allowClear
                showSearch
                onSearch={debounceFetcher}
                filterOption={false}
                notFoundContent={null}
                onClear={() => {
                  setValue('');
                }}
              >
                {comboData.map((it, i) => {
                  return (
                    <Option value={it.id} key={i}>
                      {it.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Form>
        </div>
        <div className="handle">
          <Button onClick={onClose} className="cancel">
            取消
          </Button>
          <Button
            className="confirm"
            type="primary"
            onClick={() => {
              form.submit();
            }}
          >
            保存
          </Button>
        </div>
      </DrawerStyle>
    </Drawer>
  );
};
export default Add;
